export default {
  id: "heart-world-jin-captain",
  pride: 19456,
  slug: "heart-world-jin-captain",
  series: "heart-world",
  category: ["video", "blog"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "【OC动画】心界故事：金船长之死",
    en: "[OC Animation] Heart World Story: Death of Captain Jin"
  },
  bilibiliVideoId: "BV1Hns6ztEAP",
  descriptionKey: {
    zh: "心界宇宙原创动画短片。",
    en: "Original animated short set in the Heart World universe."
  },
  date: { year: 2025, month: 10, day: 26 },
  genres: ["OC动画", "原创"],
  themes: ["心界", "原创角色"],
  developerNotesKey: {
    zh: "心界系列原创动画。",
    en: "Original animation from the Heart World series."
  },
  tags: ["心界", "AI动画"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1Hns6ztEAP/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
